module.exports = __webpack_public_path__ + "static/product-pa50-charcoal-10beff1140a6cbeba8bbbf4fe29966c3.png";